export default {
  // 具体套餐
  systemList: [
    {
      key: 1,
      imgSrc: require('@/assets/images/system/basic.png'),
      title: '基础版',
      buttonText: '免费试用',
      text1: '适用于小微企业',
      text2: '提供覆盖多端（PC、APP、客户端、小程序）的电子签名能力，满足企业基础签署的需求，简单易上手',
      text3: '费用：按使用合同份数收费',
      kindList: [
        {
          key: 1,
          icon: require('@/assets/images/system/identity_authentication.png'),
          text: '身份认证',
        },
        {
          key: 2,
          icon: require('@/assets/images/system/foundation_signature.png'),
          text: '基础签署',
        },
        {
          key: 3,
          icon: require('@/assets/images/system/signature_electronics.png'),
          text: '电子签章',
        },
        {
          key: 4,
          icon: require('@/assets/images/system/existing_evidence.png'),
          text: '存证服务',
        },
      ],
    },
    {
      key: 2,
      imgSrc: require('@/assets/images/system/professional.png'),
      title: '专业版',
      buttonText: '在线咨询',
      text1: '适用于成长型企业',
      text2: '更灵活的合同签管产品，支持合同审批流、批量签署、API接口开放、合同管理等进阶功能，签署更高效，系统对接更简单',
      text3: '费用：版本费+使用合同份数计费',
      kindList: [
        {
          key: 1,
          icon: require('@/assets/images/system/batch_signing.png'),
          text: '批量签',
        },
        {
          key: 2,
          icon: require('@/assets/images/system/approve_sign.png'),
          text: '审批流',
        },
        {
          key: 3,
          icon: require('@/assets/images/system/api_interface_open.png'),
          text: 'API接口开放',
        },
        {
          key: 4,
          icon: require('@/assets/images/system/scanning_signature.png'),
          text: '扫码签署',
        },
      ],
    },
    {
      key: 3,
      imgSrc: require('@/assets/images/system/premium.png'),
      title: '高级版',
      buttonText: '在线咨询',
      text1: '适用于中大型/集团型企业',
      text2: '多场景多组织解决方案支持，提供智能化合同管理服务，适配各类大型企业的内部业务系统与流程，提供集团型电子签章建设最佳实践',
      text3: '费用：版本费+使用合同份数计费',
      kindList: [
        {
          key: 1,
          icon: require('@/assets/images/system/multi-organization_space_management.png'),
          text: '多组织多空间管理',
        },
        {
          key: 2,
          icon: require('@/assets/images/system/ocr_paper_contract.png'),
          text: 'OCR纸质合同',
        },
        {
          key: 3,
          icon: require('@/assets/images/system/sso_single_sign.png'),
          text: 'SSO单点登录',
        },
        {
          key: 4,
          icon: require('@/assets/images/system/smart_contract_management.png'),
          text: '智能合同管理',
        },
      ],
    },
  ],

  // banner底部数据
  bannerBottomData: [
    {
      firstLineText: '19年+',
      secondLineText: '服务经验',
    },
    {
      firstLineText: '502万+',
      secondLineText: '企业服务',
    },
    {
      firstLineText: '2.7亿+',
      secondLineText: '个人用户',
    },
    {
      firstLineText: '121亿+',
      secondLineText: '总签署量',
    },
    {
      firstLineText: '24x365小时',
      secondLineText: '管家式服务',
    },
  ],
  // e签宝SaaS产品套餐
  packageTitleData: [
    {
      key: 1,
      title: '即买即用',
      desc: '1小时上线，在线极速签署电子合同',
    },
    {
      key: 2,
      title: '全终端支持',
      desc: 'web、App、短信、钉钉、小程序等',
    },
    {
      key: 3,
      title: '签审管一体',
      desc: '实现电子印章、电子合同签批存管统一管理',
    },
  ],
  // 具体套餐
  electronicCard: [
    {
      key: 1,
      name: '企业套餐A',
      money: '650',
      singleNum: '6.5',
      num: '100',
    },
    {
      key: 2,
      name: '企业套餐B',
      money: '3000',
      singleNum: '6',
      num: '500',
    },
    {
      key: 3,
      name: '企业套餐C',
      money: '5500',
      singleNum: '5.5',
      num: '1000',
    },
  ],
  productPower: {
    title: '灵活的产品部署方式',
    powerList: [
      {
        name: '公有云SaaS平台',
        iconUrl: require(`../../assets/images/sem618/power1.png`),
        toWho: '适用对象：成长型中小企业',
        descList: [
          '超高性价比选择',
          '开通即用，功能丰富，签管一体',
          '智能AI与电子合同的完美结合',
          '一处发起，多处签署',
          '覆盖PC、微信、支付宝、APP等六大端',
        ],
        link: '免费试用',
        url: 'https://www.baidu.com',
      },
      {
        name: '公有云API开放平台',
        iconUrl: require(`../../assets/images/sem618/power2.png`),
        toWho: '适用对象：中大型企业组织',
        descList: [
          '快速集成OA/CRM/SCM/EHR/ERP 等原有业务系统',
          '参数自定义，性能强，商业模式灵活',
          '多种签署体验，覆盖全部行业场景应用',
          '多种对接方案，满足深度融合需求',
          '全程取证、司法机构广泛认可',
        ],
        link: '立即接入',
        url: 'https://www.baidu.com',
      },
      {
        name: '混合云印章平台',
        iconUrl: require(`../../assets/images/sem618/power3.png`),
        toWho: '适用对象：集团型企业',
        descList: [
          '科学中立的相对方模型',
          '原文沙箱专利技术，确保隐私安全',
          '私有化部署，核心数据不出网',
          '支持“国产化信创&国际通用” 双重环境规范',
          '物电一体，整合印控仪、电子印章一体化方案',
          '1000+大型组织信息化建设应用沉淀',
        ],
        link: '立即接入',
        url: 'https://www.baidu.com',
      },
      {
        name: '钉钉智能合同',
        iconUrl: require(`../../assets/images/sem618/power4.png`),
        toWho: '适用对象：钉钉平台企业用户',
        descList: ['钉钉原生电子签名官方应用', '与钉钉多项原生功能深度融合', '支持内/外部签署场景', '已服务钉钉平台百万级客户'],
        link: '免费试用',
        url: 'https://www.baidu.com',
      },
    ],
  },

  solutions: {
    title: '行业实践解决方案',
    list: [
      {
        videoUrl: require('../../assets/video/human-resource.mp4'),
        imgUrl: require('../../assets/images/solution1.png'),
        link: '免费试用>',
        text: '人力资源',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/logistics.mp4'),
        imgUrl: require('../../assets/images/solution2.png'),
        link: '免费试用>',
        text: '物流',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/bank.mp4'),
        imgUrl: require('../../assets/images/solution3.png'),
        link: '免费试用>',
        text: '银行',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/car-leasing.mp4'),
        imgUrl: require('../../assets/images/solution4.png'),
        link: '免费试用>',
        text: '汽车',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/medical.mp4'),
        // imgUrl: require('../../assets/images/solution5.png'),
        imgUrl: require('../../assets/images/solution8.png'),
        link: '免费试用>',
        text: '医疗',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/construction.mp4'),
        // imgUrl: require('../../assets/images/solution6.png'),
        imgUrl: require('../../assets/images/solution7.png'),
        link: '免费试用>',
        text: '房地产',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/e-commerce.mp4'),
        // imgUrl: require('../../assets/images/solution7.png'),
        imgUrl: require('../../assets/images/solution6.png'),
        link: '免费试用>',
        text: 'B2B电商',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/online-education.mp4'),
        // imgUrl: require('../../assets/images/solution8.png'),
        imgUrl: require('../../assets/images/solution5.png'),
        link: '免费试用>',
        text: '在线教育',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
    ],
  },
  // 客户案例
  orgList: {
    title: '客户案例',
    orgTypeList: ['人力资源', '地产租房', '互联网+', '银行金融', '零售制造', '汽车物流', '教育旅游'],
    imgs: ['humanRes', 'logistics', 'hlw', 'bank', 'lszz', 'qqwl', 'jjly'].map((item) => {
      return require(`@/assets/images/${item}.png`)
    }),
  },
  // 关于e签宝
  eQianBao: [
    {
      key: 1,
      text: 'e签宝面向企业组织、政务服务，提供全球领先的电子合同电子签章全生命周期服务。e签宝具备安全可信的电子签名与智能履约平台、物电一体化的印章管理平台、身份认证系统、区块链证据保全与管理平台、完善的司法服务体系等先进应用。',
    },
    {
      key: 2,
      text: 'e签宝是业内唯一一家入选《2020胡润全球独角兽榜》的中国电子签名企业；于2021年9月完成中国电子签名行业首个E轮融资，金额达12亿元；同月宣布战略并购金格科技。',
    },
    {
      key: 3,
      text: '截至2021年8月底，e签宝已服务100+世界五百强客户，200+中国五百强客户，与各级政府联创1500多个政务服务应用场景，与3000+生态伙伴实现深度融合，是浙江省“最多跑一次”指定电子签供应商。',
    },
  ],
}
